// tags 实现 —— Vue 3 的 globalProperties 不会自动解包 ref/computed,
// 组件 this.tags 会拿到 ComputedRef 而非裸数组(v-if="tags.length" 失效)。
// 这里改用 getter:每次 this.tags 访问返回裸数组,惰性计算 + 缓存
let _tagsCache = null
function _getTags () {
  if (_tagsCache) return _tagsCache
  let Posts = null
  try {
    Posts = require('@/../posts/data/posts.json')
  } catch (e) {
    Posts = require('@/defaults/posts.json')
  }
  const posts = Posts.posts
  const tags = []
  for (let i = 0; i < posts.length; i++) {
    for (let j = 0; j < posts[i].tags.length; j++) {
      let index = -1
      for (let k = 0; k < tags.length; k++) {
        if (tags[k].name === posts[i].tags[j]) {
          index = k
          break
        }
      }
      if (index === -1) {
        tags.push({
          name: posts[i].tags[j],
          posts: [
            posts[i]
          ]
        })
      } else {
        tags[index].posts.push(posts[i])
      }
    }
  }
  _tagsCache = tags
  return tags
}

// 把原 Vue.mixin 的全局方法注入到 Vue 3 app 的 globalProperties
// 单独成文件,便于测试 —— main.js 顶层 import App.vue 会牵动未迁移的子组件,
// 测试只 import 这个文件就能验证契约,不必挂载组件树
export function installGlobalProperties (app) {
  app.config.globalProperties.changeTitle = function (title) {
    let Config = null
    try {
      Config = require('@/../posts/data/config.json')
    } catch (e) {
      Config = require('@/defaults/config.json')
    }
    document.title = `${title} - ${Config.config.blogTitle}`
  }

  app.config.globalProperties.getConfig = function (name = 'config.json') {
    let Config = null
    try {
      Config = require(`@/../posts/data/${name}`)
    } catch (e) {
      Config = require(`@/defaults/${name}`)
    }
    return Config
  }

  // Vue 3 globalProperties 不自动解包 computed,这里用 getter 返回裸数组
  // (之前的 bug:computed(_getTags) 让 this.tags 拿到 ComputedRef 对象,
  //  导致 ViewTags.vue v-if="tags.length" 永远 falsy,页面无数据)
  Object.defineProperty(app.config.globalProperties, 'tags', {
    get () {
      return _getTags()
    },
    enumerable: true,
    configurable: true
  })
}
